// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import request from '../src/utils/request'
import {zhTran} from '../common/lang'
// import VueAxios from 'vue-axios';
import VueI18n from 'vue-i18n'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import 'element-ui/lib/theme-chalk/display.css';
import "./assets/style/css/main.css"
import mixin from "./mixins/minxin"
import * as eventBus from './store/eventBus'
Vue.mixin(mixin)
Vue.prototype.$eventBus = eventBus;
// Vue.prototype.$bus = new Vue({});

Vue.config.productionTip = false

Vue.prototype.$store = store;
Vue.prototype.$http = request;


// zhTran('s') // 简体 
Vue.prototype.$zhTran = zhTran;
// Vue.mixin({
//   mounted() {  
//     zhTran('s')  
//   }  
// }) 


Vue.use(ElementUI);
Vue.use(VueI18n)

// 如果本地存储没有默认语言 那么默认语言就是繁体
if (!localStorage.getItem('language')) {
  localStorage.setItem('language', 'CNT')
}
const i18n = new VueI18n({
  locale: localStorage.getItem('language') || 'CNT',
  messages: {
    'CN': require('../common/lang/cn.js'),
    'CNT': require('../common/lang/tc.js'),
    'EN': require('../common/lang/en.js')
  }
});
Vue.prototype._i18n = i18n
Vue.prototype.$i18nMsg = function () {
  return i18n.messages[i18n.locale]
}
/* 为了实现element插件的多语言切换 */
// locale.i18n((key, value) => i18n.t(key, value))



/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js